import { createAction } from 'typesafe-actions';
import { IPumpingStationFlowmeterMake } from '../../../../@types/model/masterData/pumpingStation/flowMeterMake';

export default class MasterDataPumpingStationFlowmeterMakeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_FLOWMETER_MAKES', resolve => (pumps : Array<IPumpingStationFlowmeterMake>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_FLOWMETER_MAKES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}